import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { isloading } from 'features/loader/loader'
import { isMenuInProgress } from 'features/menuProgressState/menuProgressState'

function Loader() {
  const isLoading = useSelector(isloading)
  const isInProgres = useSelector(
    (state: { paymentInProcess: boolean }) => state.paymentInProcess
  )
  const isMenuInProgres = useSelector(isMenuInProgress)

  useEffect(() => {
    if (isLoading || isInProgres || isMenuInProgres)
      document.body.classList.add('show-loader')
    else document.body.classList.remove('show-loader')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isInProgres, isMenuInProgres])

  // Hide the old loader when payment processing is active (our new overlay handles it)
  const shouldShowLoader = (isLoading || isMenuInProgres) && !isInProgres

  return (
    <>
      {shouldShowLoader && (
        <div className="loader-wrapper">
          <div className="loader" />
        </div>
      )}
    </>
  )
}

export default Loader
